import Banner from './Banner.vue';

export { Banner };
export default Banner;
